import { apiFetch } from "#lib/api";

export interface Tag {
  post_count: number;
  tag: string;
}

export async function fetchProfileTags(service: string, creatorId: string): Promise<Tag[]> {
  return await apiFetch<Tag[]>(`/${service}/user/${creatorId}/tags`);
}

export async function fetchAllTags(): Promise<Tag[]> {
  return await apiFetch<Tag[]>("/posts/tags");
}
